import { createFileRoute, useRouter } from "@tanstack/react-router";

import { KybVerificationPageConnector } from "@pages/kyb-verification";

export const Route = createFileRoute("/_private/kyb-verify")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  return <KybVerificationPageConnector onGoBack={router.history.back} />;
}
